import { render, staticRenderFns } from "./TranslationsStickyTools.vue?vue&type=template&id=097599a6&scoped=true&"
import script from "./TranslationsStickyTools.vue?vue&type=script&lang=js&"
export * from "./TranslationsStickyTools.vue?vue&type=script&lang=js&"
import style0 from "./TranslationsStickyTools.vue?vue&type=style&index=0&id=097599a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097599a6",
  null
  
)

export default component.exports